// extracted by mini-css-extract-plugin
export default {"header":"Header--header--lNo8Q","btnLogin":"Header--btnLogin--tcTBR"};